import React from 'react';
import '../style/components/loading.scss';

const Loading = () => {
  return (
    <div className="loading">
      <div className="ball-scale-multiple">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loading;
